import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  businessDivisionId: string;
};

const request = ({ businessDivisionId }: RequestDataType) => {
  return new ApiClient()
    .post<ResponseMessageType>(
      `/api/managers/business_divisions/${businessDivisionId}/archiveds`,
      {},
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersBusinessDivisionsArchivedsCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
